<script lang="ts">
	import { onMount } from "svelte";
	import { on } from "svelte/events";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { GOOGLE_ANALYTICS } = getGlobalSettings();
	const deniedAll = {
		ad_storage: "denied",
		ad_user_data: "denied",
		ad_personalization: "denied",
		analytics_storage: "denied",
	};

	function revokeCookies(): void {
		gtag("consent", "update", deniedAll);
	}

	function acceptCookies(categories: readonly CookieScriptCategory[]): void {
		gtag("consent", "update", {
			ad_storage: categories.includes("targeting") ? "granted" : "denied",
			ad_user_data: categories.includes("targeting") ? "granted" : "denied",
			ad_personalization: categories.includes("targeting") ? "granted" : "denied",
			analytics_storage: categories.includes("performance") ? "granted" : "denied",
		});
	}

	function processState(): void {
		const state = CookieScript.instance.currentState();
		if (state.action === "accept") {
			acceptCookies(state.categories ?? []);
		} else {
			revokeCookies();
		}
	}

	onMount(() => {
		if (window.CookieScript?.instance) {
			processState();
		} else {
			on(window, "CookieScriptLoaded", processState, { once: true });
		}
	});

	onMount(() =>
		on(window, "CookieScriptAccept", (e) => {
			acceptCookies(e.detail.categories ?? []);
		}),
	);

	onMount(() =>
		on(window, "CookieScriptReject", () => {
			revokeCookies();
		}),
	);
	/* eslint-disable */
</script>

<svelte:head>
	{#if GOOGLE_ANALYTICS}
		<!-- Escaping <script\> not to confuse ESLint parser which mistakes <script> for Svelte instance script -->
		{@html `
			<script\>
				window.dataLayer ||= [];
				function gtag(){window.dataLayer.push(arguments);}
				gtag("consent", "default", ${JSON.stringify(deniedAll)});
			</script>
		`}
		{@html `<script async src="https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS}"></script>`}
		{@html `
			<script\>
				gtag("js", new Date());
				gtag("config", ${JSON.stringify(GOOGLE_ANALYTICS)});
			</script>
		`}
	{/if}
</svelte:head>
